module.exports = __webpack_public_path__ + "img/QS.9026849b.png";